import React from 'react';
import PropTypes from 'prop-types';

import {
  ContextBar,
  LeftContent,
  RightContent,
  PreviousPageTitle,
  Link,
  BackIcon,
  ContextBarContainer,
} from './ContextBar.styled';

const ContextBarComponent = ({
  prevPageTitle,
  prevLocation,
  RightComponent,
  BottomComponent,
}) => (
  <ContextBarContainer id="context-bar">
    <ContextBar aria-label="context bar">
      <LeftContent>
        <Link to={prevLocation} aria-label="back button">
          <BackIcon />
        </Link>
        <PreviousPageTitle aria-label="previous page title">
          {prevPageTitle}
        </PreviousPageTitle>
      </LeftContent>
      <RightContent>{RightComponent}</RightContent>
    </ContextBar>
    {BottomComponent}
  </ContextBarContainer>
);

ContextBarComponent.propTypes = {
  prevPageTitle: PropTypes.string.isRequired,
  RightComponent: PropTypes.node,
  prevLocation: PropTypes.string.isRequired,
  BottomComponent: PropTypes.node,
};

ContextBarComponent.defaultProps = {
  RightComponent: null,
  BottomComponent: null,
};

export default ContextBarComponent;
